export default "__VITE_ASSET__ClaEZGuR__"